/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'yurstrap';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    icon: PropTypes.string.isRequired,
    delay: PropTypes.number,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'span',
    delay: 10 * 1000,
};

const IconLoader = (props) => {
    const classNames = [
        's-icon-loader',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    const getIterationCount = () => {
        if (props.delay < 0) {
            return 'infinite';
        }
        return 1;
    };
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <span className="s-icon-loader__left">
                <span
                    className="s-icon-loader__animation"
                    style={{
                        cursor: 'pointer',
                        animationDelay: '0s',
                        animationDuration: `${(props.delay < 0 ? 3 : props.delay * 2)}s`,
                        animationIterationCount: getIterationCount(),
                    }}
                />
            </span>
            <Icon icon={props.icon} />
            <span className="s-icon-loader__right">
                <span
                    className="s-icon-loader__animation"
                    style={{
                        cursor: 'pointer',
                        animationDelay: `${props.delay < 0 ? 3 : props.delay / 2}s`,
                        animationDuration: `${(props.delay < 0 ? 3 : props.delay * 2)}s`,
                        animationIterationCount: getIterationCount(),
                    }}
                />
            </span>
        </props.componentClass>
    );
};

IconLoader.propTypes = propTypes;

IconLoader.defaultProps = defaultProps;

export default IconLoader;
